import { render } from "./UserBills.vue?vue&type=template&id=e1a258da&scoped=true"
import script from "./UserBills.vue?vue&type=script&lang=js"
export * from "./UserBills.vue?vue&type=script&lang=js"

import "./UserBills.vue?vue&type=style&index=0&id=e1a258da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e1a258da"

export default script